import {Col, Row} from "antd";
import styled from "styled-components";
import React from "react";

export const OrderBlockContainer = styled(({isLast, ...props}) => <Row {...props} />)`
    width: 100%;
    border-bottom: ${props => (props.isLast ? "none" : "1px dashed #c6c5c5")};
    padding: ${props => (props.isLast ? "20px 0 0px 0" : "20px 0 20px 0")};
    flex-direction: column;
    gap: 20px !important;
`;

export const OrderBlockHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
`;

export const OrderBlockTitle = styled(Col)`
    font-size: 18px;
    margin-left: 7px;
`;
